var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 400,
    viewBox: "0, 0, 400,400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0",
    d: "M16.406 2.215 C 10.583 4.814,3.858 11.868,1.662 17.680 C -1.092 24.968,-0.621 376.775,2.151 383.253 C 4.753 389.334,11.694 396.077,17.680 398.338 C 23.835 400.664,376.165 400.664,382.320 398.338 C 388.306 396.077,395.247 389.334,397.849 383.253 C 401.050 375.772,401.050 24.228,397.849 16.747 C 395.247 10.666,388.306 3.923,382.320 1.662 C 375.172 -1.039,22.502 -0.506,16.406 2.215 M108.016 61.766 C 135.422 81.069,120.688 123.342,87.177 121.557 C 53.782 119.779,43.942 75.521,73.438 59.765 C 83.628 54.322,98.684 55.193,108.016 61.766 M293.699 149.180 C 314.921 156.730,329.288 172.704,336.421 196.683 C 339.215 206.076,339.566 213.198,340.226 273.828 L 340.952 340.625 311.170 340.625 L 281.388 340.625 280.928 280.078 C 280.481 221.081,280.380 219.366,277.022 213.087 C 262.560 186.052,221.849 192.357,211.203 223.280 C 209.940 226.950,209.375 245.900,209.375 284.608 L 209.375 340.625 179.688 340.625 L 150.000 340.625 150.000 245.313 L 150.000 150.000 178.125 150.000 L 206.250 150.000 206.281 163.672 L 206.311 177.344 212.090 170.449 C 230.617 148.345,265.671 139.209,293.699 149.180 M118.750 245.313 L 118.750 340.625 89.063 340.625 L 59.375 340.625 59.375 245.313 L 59.375 150.000 89.063 150.000 L 118.750 150.000 118.750 245.313 ",
    stroke: "none",
    fill: "#0077B5",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b4cec1bff68bdeb60fdfbb51ad27f94d.svg";
export { ForwardRef as ReactComponent };